import { BaseOauthClient } from "./base";

export class AirtableOauthClient extends BaseOauthClient {
  provider = "airtable";
  baseUrl = "https://www.airtable.com";
  clientId = process.env.AIRTABLE_CLIENT_ID || "";
  clientSecret = process.env.AIRTABLE_CLIENT_SECRET || "";

  authorizationEndpoint = '/oauth2/v1/authorize';
  tokenEndpoint = "/oauth2/v1/token";

  scopes = ["schema.bases:read", "data.records:read"];

  constructor(team: string, supabaseClient: any, id: string, credentials?: { clientId: string, clientSecret: string }) {
    super(team, supabaseClient, id, credentials);
  }

  async getRecords(baseId: string, tableId: string) {
    const MAX_RETRIES = 5;
    const INITIAL_BACKOFF = 1000; // 1 second

    try {
      let allRecords: any[] = [];
      let offset: string | undefined;

      do {
        let retries = 0;

        while (true) {
          try {
            const url = new URL(`https://api.airtable.com/v0/${baseId}/${tableId}`);
            if (offset) {
              url.searchParams.append("offset", offset);
            }

            const response = await this.fetcher.fetch(url.toString());
            const output = await response.json();

            if (output?.errors && output?.errors[0] && output?.errors[0].error === "RATE_LIMIT_REACHED") {
              if (retries >= MAX_RETRIES) {
                throw new Error("Rate limit exceeded. Max retries reached.");
              }
              const backoff = INITIAL_BACKOFF * Math.pow(2, retries); // Exponential backoff
              await new Promise((resolve) => setTimeout(resolve, backoff));
              retries++;
              continue;
            }

            allRecords = allRecords.concat(
              output.records.map((a: any) => {
                let obj = { _id: a.id, ...a.fields };
                Object.keys(obj).forEach((key) => {
                  if (Array.isArray(obj[key])) {
                    obj[key] = obj[key].join(",");
                  }
                });
                return obj;
              })
            );

            offset = output.offset;
            break; // Exit retry loop on success

          } catch (err: any) {
            console.log("AIRTABLE ERROR: ", err)
            throw err;
          }
        }
      } while (offset);

      return allRecords;
    } catch (e: any) {
      throw new Error(e.message);
    }
  }
}
